import React, { useState } from 'react'
import './escrow.css';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { useNavigate } from 'react-router-dom';
import Nav from '../Nav/Nav'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import ownDeed from '../imgs/ownDeed.jpg'

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';


const Escrow = () => {
    const navigate=useNavigate();
    async function  toastAdd(){
      toast.success('Please fill the details on next page.')
      setTimeout(()=>{navigate('/verifycustomer')},3000);
    }

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  

  return (
    <div>
        <Nav/>

        <div className="EscrowLeft">
            <div className="Title">Escrow Property</div>

            <div className="EscrowLeft12">
            <div className="EscrowTitle" id="title" >Address </div>
              <textarea  style={{"width":"12vw","height":"10vh","border":"1px solid grey"}} value="c/3, Kohinoor Apartment ,Andheri(W)" disabled></textarea>
            </div>

            <div className="EscrowLeft12">
            <div className="EscrowTitle" id="title" >Seller Name </div>
            <input type="text" name="gate" id="apart" value="Henry B" disabled/>
            </div>

            <div className="EscrowLeft12">
            <div className="EscrowTitle" id="title" >Seller Id </div>
            <input type="text" name="gate" id="apart" value="839211" disabled/>
            </div>

            <div className="EscrowLeft1">
               <div className="EscrowTitle" id="EscrowTitle" >Category</div>
               <input type="text" name="gate" id="apart" value="Apartment" disabled/>
            </div>
            <div className="EscrowLeft2">
                <span className='EscrowTitle'> Price </span>{" "} <br/> <br/>
                <input type="text" name="gate" id="apart" value="20,000" disabled/>
            </div>

            <div className="EscrowLeft3">
              <div className="EscrowTitle">Rooms</div>
              <div className="EscrowLeft3Content">
              <input type="text" name="room" id="room" value="1BHK" disabled/>
            </div>
            </div><br/>

            <div className="EscrowLeft4">
              <div className="EscrowTitle">Sq Ft</div>
              <div className="EscrowLeft3Content">
              <input type="text" name="room" id="room" value="3000 sq ft" disabled/>
            </div>
            </div><br/>

            <div className="EscrowLeft8">
              <div className="EscrowTitle">Available By</div>
              <div className="EscrowLeft4Content">
              <input type="text" name="available" id="available" value="july 24, 2023" disabled/>
              </div>
            </div>

            <div className="EscrowLeft12">
               <div className="EscrowTitle" id="title" >City</div>
               <input type="text" name="room" id="room" value="Mumbai" disabled/>
            </div>

            <div className="EscrowLeft13">
               <div className="EscrowTitle" id="title" >State</div>
               <input type="text" name="room" id="room" value="Maharashtra" disabled/>
            </div>

            <div className="EscrowLeft14">
            <div className="EscrowTitle" id="title" >Proof of Ownership</div>
            <Button onClick={handleOpen} ><button>View proof</button></Button>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modalBox">
                <Typography id="modal-modal-title" variant="h6" component="h2">
                 Scanned copy of sales deed
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  <img src={ownDeed} alt="deed" style={{"height":"80vh","width":"auto"}}/>
                </Typography>
              </Box>
            </Modal>
            </div>

            <div className='SubmitEscrow'>
              <button className="SubmitFormButton" onClick={toastAdd}>Escrow property</button>
            </div>
        </div>

        <ToastContainer/>

    </div>
  )
}

export default Escrow